<template>
    <button 
        :class="classes"
        @click.stop="purchaseOutfit">
        {{isOutfitInCart ? 'Added to Cart' : 'Purchase Outfit'}}
    </button>
</template>

<script>
    import { mapGetters } from 'vuex';
    import {_} from "vue-underscore";

    export default {
        props: {
            classes: String|Array|Object,
            outfit: Object,
        },
        computed: {
            isOutfitInCart() {
                const { outfit } = this;
                return outfit && _.some(this.cartOutfits, (cartOutfit, outfitId) => {
                    return (
                        outfitId == outfit.outfit_id &&
                        _.every(outfit.products, product => {
                            return _.some(cartOutfit, cartProduct => {
                                return product.product_id == cartProduct.product_id;
                            });
                        })
                    );
                });
            },
            ...mapGetters({
                cartOutfits: 'cart/getCartOutfits',
            }),
        },
        methods: {
            purchaseOutfit(event) {
                if(this.isOutfitInCart || !this.outfit.outfit_id) return;

                this.$emit('click', event);
                this.$router.push({
                    path: '/purchase-outfit',
                    query: {
                        outfitId: this.outfit.outfit_id,
                        outfitType: this.outfit.type,
                    }
                });
            },
        }
    }
</script>
